<template>
  <v-card>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="confirm"
    >
      <v-card-title>
        Exporta till Excel
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-dialog
              ref="fromDateDialog"
              v-model="dateModalFrom"
              :return-value.sync="model.from"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  filled
                  :rules="[dateFromRule]"
                  v-model="model.from"
                  label="Start datum"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="sv"
                first-day-of-week="1"
                v-model="model.from"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateModalFrom = false"
                  >Avbryt</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.fromDateDialog.save(model.from)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col>
            <v-dialog
              ref="toDateDialog"
              v-model="dateModalTo"
              :return-value.sync="model.to"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  filled
                  :rules="[dateToRule]"
                  v-model="model.to"
                  label="Slut datum"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="sv"
                first-day-of-week="1"
                v-model="model.to"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateModalTo = false"
                  >Avbryt</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.toDateDialog.save(model.to)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text tile @click="close">
          Avbryt
        </v-btn>
        <v-btn color="primary" tile type="submit" :disabled="!valid">
          Exportera
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { format, addMonths, isAfter, isBefore } from 'date-fns'

export default {
  name: 'ExportModal',

  data: () => ({
    valid: true,
    dateModalFrom: false,
    dateModalTo: false,
    model: {
      from: format(addMonths(new Date(), -1), 'yyyy-MM-dd'),
      to: format(new Date(), 'yyyy-MM-dd')
    }
  }),

  methods: {
    close() {
      this.$emit('close')
    },

    dateFromRule(v) {
      return (
        isBefore(new Date(v), new Date(this.model.to)) ||
        'Måste vara efter slut datum'
      )
    },

    dateToRule(v) {
      return (
        isAfter(new Date(v), new Date(this.model.from)) ||
        'Måste vara före start datum'
      )
    },

    async confirm() {
      const isValid = await this.$refs.form.validate()
      if (!isValid) return
      this.$emit('confirm', this.model)
      this.close()
    }
  }
}
</script>
